export const PROTOCOL_STATUSES = {
  NEW: 1,
  ACTIVE: 2,
  MAINTAINING: 3,
  COMPLETED: 4,
  INDIVIDUALIZATION: 5,
};

export const DIRECTORY_TYPES = {
  TEACHING_METHOD: 1,
  HINT_TYPE: 2,
  REDUCTION_HINT_METHOD: 3,
  CRITERIA_END_SESSION: 4,
  CRITERIA_END_TEACHING: 5,
  CRITERIA_END_PROTOCOL: 6,
  APPLYING: 7,
};

export const STATUS_NEW = 1;
export const STATUS_ACTIVE = 2;
export const STATUS_MAINTAINING = 3;
export const STATUS_COMPLETED = 4;

export const TRANSFER_CONDITION = {
  ONE_TRIAL: 'one_trial',
  TRIAL_IN_A_ROW: 'trial_in_a_row',
  SESSION_IN_A_ROW: 'session_in_a_row',
  RATIO: 'ratio'
};

export const DATAPICKER = process.env.DATAPICKER;

export const PROTOCOL_TYPE = {
  DTT: '1',
  SIMPLE: '2',
  MAND: '3',
  USD: '4',
  CHAIN: '5',
  SHAPING: '6',
  PECS: '7',
  PECSDESTINATION: '8',
  PECSWITHDISCRIMINATION: '9',
  PECSWITHITEMS: '10',

};






// WEBPACK FOOTER //
// ./src/modules/protocols/constants.js